import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../../lib/api';
import { useGo } from '../../../navigation/nav';
import { OrgChart } from '../components/OrgChart';
import { Card, EmptyState, ErrorState, Loading, PageHeader, Screen } from '../../../ui';

/** Company-wide org chart. */
export function OrgChartScreen() {
  const go = useGo();
  const q = useQuery({ queryKey: ['org-chart', 'all'], queryFn: () => api.org.chart() });
  return (
    <Screen refreshing={q.isRefetching} onRefresh={() => q.refetch()} testID="org-chart-screen">
      <PageHeader title="Org chart" subtitle="Reporting lines with dotted-line managers called out." />
      {q.isLoading ? (
        <Loading />
      ) : q.isError ? (
        <ErrorState error={q.error} onRetry={() => q.refetch()} />
      ) : !q.data?.length ? (
        <Card><EmptyState icon="sitemap" title="No reporting structure yet" /></Card>
      ) : (
        <OrgChart roots={q.data} onSelect={(id) => go('EmployeeDetail', { id })} />
      )}
    </Screen>
  );
}
